<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="https://disctools.co.uk/img/DiSCloudBlack.png" />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" :to="{ path: '/customers' }">Customers</b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ path: '/providers' }">Providers</b-navbar-item>
      <b-navbar-dropdown label="Statistics">
        <b-navbar-item tag="router-link" :to="{ path: '/statistics/providers/requests' }">Provider Requests</b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/statistics/customers/selected' }">Customer Selected Breakdown</b-navbar-item>
      </b-navbar-dropdown>
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <div class="buttons">
          <router-link v-if="this.$store.state.name === ''" class="button is-light" :to="{ path: 'login' }">Log in</router-link>
          <div style="display: flex;align-items: center;" else>
            <b-select v-if="this.loaded" v-bind:value="this.currentSelected" style="margin-right: 15px;" v-on:input="onChange">
              <option v-for="region in this.regions" :value="region.Name" :key="region.Name">{{ region.Name }}</option>
            </b-select>
            <span style="margin-right: 10px;">Welcome, {{ this.$store.state.name }}</span>
            <a style="margin-bottom: inherit;" v-on:click="logout" class="button is-light">Log out</a>
          </div>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
// @ is an alias to /src
const GlobalConfig = require("../../config/index");

export default {
  name: "headerView",
  data() {
    return {
      loaded: false,
      regions: [],
      currentSelected: ""
    };
  },
  beforeMount() {
    this.regions = GlobalConfig.API_SERVERS;
    this.currentSelected = GlobalConfig.GetAPIName();
    this.loaded = true;
  },
  methods: {
    logout() {
      localStorage.removeItem("DiSCToolsToken");
      this.$store.state.name = "";
      this.$router.push("/login");
    },
    onChange(changedTo) {
      localStorage.setItem("APIName", changedTo);
      this.$router.go();
    }
  }
};
</script>
